define('controllers/conversations/Podio.Controllers.Conversations.Chat',['require','underscore','jquery','jquery.cookie','lib/backbone/Backbone.PodioController','controllers/conversations/Podio.Controllers.Conversations.List','controllers/conversations/Podio.Controllers.Conversations.New','controllers/conversations/Podio.Controllers.Conversations.Notifications','views/conversations/Podio.Views.Conversations.Chat.Main','views/conversations/Podio.Views.Conversations.Chat.Show','views/conversations/Podio.Views.Conversations.Chat.List','controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main','views/conversations/Podio.Views.Conversations.Chat.People','lib/Podio.Routes','lib/Podio.Config','lib/Podio.Event','lib/Podio.Transport.Picker','controllers/conversations/Podio.Controllers.Conversations.ConversationCollection'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('jquery.cookie');

  var PodioController = require('lib/backbone/Backbone.PodioController');

  var ConversationListController = require('controllers/conversations/Podio.Controllers.Conversations.List');
  var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');
  var ControllerConversationsNotifications = require('controllers/conversations/Podio.Controllers.Conversations.Notifications');

  var ChatMainView = require('views/conversations/Podio.Views.Conversations.Chat.Main');
  var ChatConversationView = require('views/conversations/Podio.Views.Conversations.Chat.Show');
  var ChatListView = require('views/conversations/Podio.Views.Conversations.Chat.List');
  var ControllerPeopleFinderMain = require('controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main');
  var ChatPeopleView = require('views/conversations/Podio.Views.Conversations.Chat.People');

  var routes = require('lib/Podio.Routes');
  var podioConfig = require('lib/Podio.Config');
  var podioEvent = require('lib/Podio.Event');
  var transportPicker = require('lib/Podio.Transport.Picker');

  return PodioController.extend({

    initialize: function(options) {
      _.bindAll(this, 'onConversationClicked', 'onPersonSelected', 'onStartConversationFromGenericLink', 'showExistingConversation', 'onChatNotificationClicked');

      this._super();

      this.elmContainer = options.elmContainer;
      this.placeholderConversation = null; // Holds a refernece to any conversation currently shown outside the regular list of conversations

      this._initSharedState();
      this._initChatMainView();

      this._bindEvents();

      this.newConversationController = ControllerConversationNew.getSingleton({ eventBus: this.eventBus });
      this.notificationsController = new ControllerConversationsNotifications();
    },

    _initSharedState: function() {
      this.sharedState = {
        selectedConversationModel: null
      };
    },

    _initChatMainView: function() {
      this.chatMainView = new ChatMainView({
        eventBus: this.eventBus,
        elm: this.elmContainer
      });
    },

    _disposeChatMainView: function() {
      if (this.chatMainView) {
        this.chatMainView.dispose();
        delete this.chatMainView;
      }
    },

    _initCollectionController: function() {

      var ConversationCollectionController = require('controllers/conversations/Podio.Controllers.Conversations.ConversationCollection');

      this.conversationCollectionController = new ConversationCollectionController({
        eventBus: this.eventBus,
        itemsPerRequest: 8, // Number of conversations to show in the chat pane
        maxItems: 8 // Max number of conversations allowed in each collection
      });
    },

    _disposeCollectionController: function() {
      if (this.conversationCollectionController) {
        this.conversationCollectionController.dispose();
        delete this.conversationCollectionController;
      }
    },

    _ensureChatPaneIsOpen: function(options) {
      if (this.chatMainView.paneIsOpen) {
        return $.Deferred().resolve();
      } else {
        return this.showChatPane(null, options);
      }
    },

    dispose: function() {
      this.disposeChildren();

      this.stopListening();
      this._unbindEvents();
      this._disposeChatMainView();
      this._disposeCollectionController();
    },

    disposeChildren: function() {
      this.elmConversationContainer.remove();
      this.conversationsListController.dispose();
      delete this.conversationsListController;

      if (this.peopleView) {
        this.peopleView.dispose();
      }
      delete this.peopleView;
    },

    bootup: function() {
      // Show chat immediately if it was open on last page load
      // unless we are on the conversations page
      if (this._getPersistedChatPaneIsOpen() && !this._isOnConversationsPage()) {
        this.showChatPane(this._getPersistedChatPaneConversationId(), {takeFocus: false});
      }
    },

    _bindEvents: function() {
      this.listenTo(this.eventBus, 'chatMainView:anchorClicked', this.onAnchorClicked);
      this.listenTo(this.eventBus, 'chatMainView:navigationChanged', this.onNavigationChanged);
      this.listenTo(this.eventBus, 'chatMainView:closeChatPane', this.onCloseChatPaneTriggered);
      this.listenTo(this.eventBus, 'conversation:click', this.onConversationClicked);
      this.listenTo(this.eventBus, 'showConversation:leftConversation', this.onLeftConversation);
      this.listenTo(this.eventBus, 'chatPeopleView:userSelected', this.onPersonSelected);
      this.listenTo(this.eventBus, 'conversationListView:rendered', this.onConversationListRendered);
      this.listenTo(this.eventBus, 'newConversationController:startDirectConversation', this.onStartConversationFromGenericLink);
      this.listenTo(this.eventBus, 'newConversation:click', this.onNewConversation);

      podioEvent.bind(podioEvent.Types.onChatNotificationClicked, this.onChatNotificationClicked);
    },

    _unbindEvents: function() {
      podioEvent.unbind(podioEvent.Types.onChatNotificationClicked, this.onChatNotificationClicked);
    },

    _getPersistedChatPaneIsOpen: function() {
      // Cannot rely on the cookie, has to check the dom as we could be rendering a cached version of a page
      return $('.state-chat-pane-open').length > 0;
    },

    _setPersistedChatPaneIsOpen: function(value) {
      $.cookie('chat-pane-is-open', value, { path: '/', domain: podioConfig.base_domain});
    },

    _getPersistedChatPaneConversationId: function() {
      var conversationId = $.cookie('podio-chat-pane-conversation-id');
      if (conversationId) {
        return parseInt(conversationId, 10);
      } else {
        return null;
      }
    },

    _setPersistedChatPaneConversationId: function(conversationId) {
      $.cookie('podio-chat-pane-conversation-id', conversationId, { path: '/', domain: podioConfig.base_domain});
    },

    _isOnConversationsPage: function() {
      return location.pathname === routes.html_conversations_path({format: ''});
    },

    onNavigationChanged: function(menuItem) {
      if (menuItem === 'contactList') {
        this.switchToContactList();
      }
    },

    onConversationClicked: function(model) {
      this.selectConversation(model);
    },

    selectConversation: function(model) {
      if (!this.sharedState.selectedConversationModel || this.sharedState.selectedConversationModel.get('id') !== model.get('id')) {
        this.sharedState.selectedConversationModel = model;
        this._setPersistedChatPaneConversationId(this.sharedState.selectedConversationModel.get('id'));
        this.switchToConversations();
      }
    },

    onLeftConversation: function(model) {
      if (this.sharedState.selectedConversationModel && this.sharedState.selectedConversationModel.get('id') === model.get('id')) {
        this.switchToContactList();
      }
    },

    onCloseChatPaneTriggered: function() {
      this.hideChatPane();
    },

    onPersonSelected: function(user) {
      this.showOrInitDirectConversation(user.get('id'), user);
    },

    onStartConversationFromGenericLink: function(userId) {
      this.showOrInitDirectConversation(userId);
    },

    onNewConversation: function(conversation) {
      this.peopleFinder = new ControllerPeopleFinderMain([
        {type: 'podio', visible: true, excludeSelf: true},
        {type: 'mail', visible: true},
        {type: 'linkedAccounts', visible: true, contactable: true}
      ]);

      if (conversation) {
        var userIds = _.pluck(conversation.getOtherParticipants(), 'id');

        transportPicker.getContactsData('single_user', userIds, _.bind(function(responseData) {
          this.peopleFinder.populate({user: _.clone(responseData)});
        }, this));
      }

      this.peopleFinder.signals.onDone.add(this.onPeopleFinderDone, this);
      this.peopleFinder.signals.onClose.add(this._disposePeopleFinder, this);
      this.peopleFinder.show();
    },

    onPeopleFinderDone: function(data) {
      var self = this;

      var participantMap = _.flatten(_.map(data.attributes, function(coll, key) {
        return coll ? _.map(coll, function(ref) {
          if ( ref.ref_type === 'external' ) {
            return 'external|' + ref.linked_account_id + '|' + ref.external_contact_id;
          } else {
            return ref.ref_type + '|' + ref.id;
          }
        } ) : [];
      }));

      if (participantMap.length === 0) {
        return;
      }

      this.conversationCollectionController.createConversation({
        'participant_list': participantMap
      }, function(conversation, errorNotPropagate) {
        if (!_.isNull(conversation)) {
          var conversationId = conversation.get('id');

          self.switchToConversations();
          self.conversationsListController.showConversation(conversation, { forceRender: true });
          self.chatMainView.selectNavigationItem('conversation:' + conversationId);
          self.sharedState.selectedConversationModel = conversation;
          self._setPersistedChatPaneConversationId(conversationId);
        }
      });

      this._disposePeopleFinder();
    },

    _disposePeopleFinder: function() {
      this.peopleFinder.signals.onDone.remove(this.onPeopleFinderDone);
      this.peopleFinder.signals.onClose.remove(this._disposePeopleFinder);
      this.peopleFinder.destroy();
      delete this.peopleFinder;
    },

    onConversationListRendered: function() {
      if (this.placeholderConversation) {
        var self = this;
        var listConversation = this.conversationCollectionController.collections.all.find(function(conversation) {
          return conversation.get('id') === self.placeholderConversation.get('id');
        });
        if (listConversation) {
          // Placeholder conversation is now in the list, don't show it outside the list anymore
          this.hidePlaceholderNavigationItem();

          // If this conversation is currently selected, move that selection to the new nav item in the list
          if (this.sharedState.selectedConversationModel && this.sharedState.selectedConversationModel.get('id') === listConversation.get('id')) {
            this.chatMainView.selectNavigationItem('conversation:' + listConversation.get('id'));
            this.conversationsListController.showConversation(listConversation, {forceRender: true});
          }
        }
      }
    },

    onChatNotificationClicked: function(e, conversationId) {
      this.showConversationById(conversationId);
    },

    showConversationById: function(conversationId) {
      var conversation;

      // chat pane is already open and has either a selected conversation or not
      if (this._getPersistedChatPaneIsOpen()) {
        // if we are already on the same conversation, do nothing
        if (this.sharedState.selectedConversationModel && this.sharedState.selectedConversationModel.get('id') === conversationId) {
          return true;
        }

        // if we have a different or no conversation selected, proceed
        conversation = this.conversationCollectionController.getConversationById('all', conversationId);

        if (conversation) {
          this.selectConversation(conversation);
          this.conversationsListController.showConversation(conversation);
          this.chatMainView.selectNavigationItem('conversation:' + conversationId);
        }
      } else {
        // chat pane is closed
        this.showChatPane(conversationId);
      }
    },

    showChatPane: function(conversationId, options) {
      if (this.chatMainView && this.chatMainView.paneIsOpen) {
        return $.Deferred().resolve();
      }

      conversationId = conversationId || this._getPersistedChatPaneConversationId();

      var chatReady;
      options = _.extend({
        takeFocus: true,
        renderInitialView: true
      }, options || {});

      this._initCollectionController();

      this.chatMainView.render();

      this.elmContactListContainer = this.chatMainView.elmDetailsColumn.find('.contact-list-container');
      this.elmConversationContainer = this.chatMainView.elmDetailsColumn.find('.show-conversation-container');

      chatReady = this.renderConversationsList();

      if (!conversationId && options.renderInitialView) {
        this.renderInitialView();
      }

      podioEvent.trigger(podioEvent.Types.beforeChatPaneOpened);

      this.chatMainView.show(options).done(function() {
        if (conversationId) {
          chatReady.done(this.showExistingConversation.curry(conversationId, options));
        }

        this._setPersistedChatPaneIsOpen(true);
        podioEvent.trigger(podioEvent.Types.chatPaneOpened);

        this.notificationsController.supressBubbles();
      }.bind(this));

      return chatReady;
    },

    hideChatPane: function() {
      if (this.chatMainView && !this.chatMainView.paneIsOpen) {
        return false;
      }

      this.disposeChildren();
      this.sharedState.selectedConversationModel = null;
      this._setPersistedChatPaneIsOpen(false);
      this._setPersistedChatPaneConversationId(null);

      podioEvent.trigger(podioEvent.Types.beforeChatPaneClosed);
      this.chatMainView.hide().done(function() {
        podioEvent.trigger(podioEvent.Types.chatPaneClosed);
      });
      this._disposeCollectionController();

      this.notificationsController.stopSupressingBubbles();
    },

    toggleChatPane: function(takeFocus) {
      if (this.isPersistedChatPaneOpen()) {
        this.hideChatPane();
      } else {
        this.showChatPane(null, {
          takeFocus: takeFocus
        });
      }
    },

    isPersistedChatPaneOpen: function() {
      return this._getPersistedChatPaneIsOpen();
    },

    renderInitialView: function() {
      this.renderContactList();
      this.chatMainView.selectNavigationItem('contactList');
    },

    showExistingConversation: function(conversationId, options) {
      var conversation = this.conversationCollectionController.getConversationById('all', conversationId);

      if (conversation) {
        this.conversationsListController.showConversation(conversation, options);
        this.chatMainView.selectNavigationItem('conversation:' + conversationId);
        this.sharedState.selectedConversationModel = conversation;
        this._setPersistedChatPaneConversationId(conversationId);
      } else {
        // Conversation not found in the list, just display contact list instead
        this.switchToContactList();
      }
    },

    renderConversationsList: function() {
      this.conversationsListController = new ConversationListController({
        eventBus: this.eventBus,
        mainViewClass: ChatConversationView, // This is reference to viewClass
        listViewClass: ChatListView, // This is reference to viewClass
        elmTarget: this.chatMainView.elmConversationsList,
        elmMainViewTarget: this.elmConversationContainer,
        presenceFeatures: ['typing'],
        conversationCollectionController: this.conversationCollectionController,
        sharedState: this.sharedState,
        headerCounters: this.options.headerCounters
      });

      return this.conversationsListController.renderList();

    },

    disposeConversation: function() {
      this.elmConversationContainer.addClass('hidden');
    },

    disposeContactList: function() {
      this.elmContactListContainer.addClass('hidden');
    },

    /*
    *  options:
    *   * takeFocus: Put focus in the search field after having rendered it
    */
    renderContactList: function(options) {

      this.disposeConversation();

      this.elmContactListContainer.removeClass('hidden');

      if (!this.peopleView) {
        this.peopleView = new ChatPeopleView({
          eventBus: this.eventBus,
          elm: this.elmContactListContainer
        });

        this.peopleView.render();
      }

      if (options && options.takeFocus) {
        this.peopleView.focusSearchField();
      }
    },

    switchToConversations: function() {
      // Hide contact list
      this.disposeContactList();

      // Show conversation list
      this.elmConversationContainer.removeClass('hidden');
      this.chatMainView.showConversationBox();
    },

    switchToContactList: function() {
      this.sharedState.selectedConversationModel = null;
      this._setPersistedChatPaneConversationId(null);
      this.chatMainView.hideConversationBox();
      this.renderContactList({takeFocus: true});
      this.chatMainView.selectNavigationItem('contactList');
    },

    showPlaceholderNavigationItem: function(conversation) {
      this.placeholderConversation = conversation;
      this.sharedState.selectedConversationModel = conversation;
      this.chatMainView.renderPlaceholderNavigationItem(conversation);
      this.chatMainView.selectNavigationItem('conversation:' + (conversation.get('id') ? conversation.get('id') : 'placeholder'));
    },

    hidePlaceholderNavigationItem: function() {
      this.chatMainView.destroyPlaceholderNavigationItem();
      this.placeholderConversation = null;
    },

    // userModel is optional - if not given, it will be loaded
    showOrInitDirectConversation: function(userId, userModel) {
      var self = this;

      // Ensure that chat pane is open
      var dfdChatReady = this._ensureChatPaneIsOpen({ renderInitialView: false });

      // Indicate that we are doing something useful
      this.switchToConversations();
      this.conversationsListController.indicateConversationLoading();

      // If the chat pane was closed, we can't continue until the conversations for it has finished loading
      dfdChatReady.done(function() {
        // Load any existing direct conversation with this user
        var dfdConversation = self.conversationCollectionController.findOrCreateDirectConversationForUser(userId);

        dfdConversation.done(function(conversation, state) {
          self.conversationsListController.showConversation(conversation, { forceRender: true });
          self.sharedState.selectedConversationModel = conversation;
          if (state === 'listed') {
            self.chatMainView.selectNavigationItem('conversation:' + conversation.get('id'));
          } else {
            self.showPlaceholderNavigationItem(conversation);
          }
        });
      });
    }

  });

});

